exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 581px) and (max-width: 1199px) {\n.sub-total-row--top {\n    flex-direction: row !important;\n}\n.sub-total-row--top .added-to-cart .product-details .product-title h1 {\n    margin-top: 0;\n}\n.sub-total-row--top .sub-total {\n    flex: 0.65;\n    flex-direction: column;\n    align-items: flex-end;\n}\n.sub-total-row--top .sub-total-details {\n    margin: 0 0 10px 0;\n}\n.sub-total-row--top .sub-total-action {\n    width: 100%;\n}\n.sub-total-row--top .sub-total-action .continue-to-cart {\n    width: 100%;\n    margin-left: 0;\n}\n}", ""]);

// exports
